import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ColumnDef } from '@tanstack/react-table';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadExcelButton } from './DownloadExcelButton';
import { OrdersFiltersPanel } from './OrdersFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  columns: ColumnDef<any>[];
  selectedColumns: string[];
  onColumnsChange: (newSelected: string[]) => void;
  filterConditions: FilterConditionOutput[];
  search?: string;
  statusId?: number;
  sorting?: { field: string; direction: 'asc' | 'desc' };
  hasTeamData?: boolean;
  searchTerm: string;
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  columns,
  selectedColumns,
  onColumnsChange,
  filterConditions,
  search,
  statusId,
  sorting,
  hasTeamData = false,
  searchTerm,
}: FiltersSectionProps) => {
  const { t } = useTranslation('ordersModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  // Calcular número de filtros activos
  const activeFiltersCount = useMemo(() => {
    return filterConditions.length;
  }, [filterConditions]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />

      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="filters-toggle-button"
      >
        <OrdersFiltersPanel initialConditions={filterConditions} onChange={onFilterChange} hasTeamData={hasTeamData} />
      </FiltersDropdown>

      <ColumnSelector
        columns={columns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        storageKey="orders-ag-grid-table"
      />
      <DownloadExcelButton
        filterConditions={filterConditions}
        search={search}
        statusId={statusId}
        sorting={sorting}
        visibleColumns={selectedColumns}
      />
    </>
  );
};
